export default {
    ToggleShouldShowAllGroups: {
        datapoint: {
            name: 'GroupList_ToggleShouldShowAllGroups',
            customData: function (isShowingAllGroups, joinedGroupCount) {
                return {
                    isShowMore: !isShowingAllGroups,
                    joinedGroupCount: joinedGroupCount >= 21 ? '21+' : joinedGroupCount,
                };
            },
        },
    },
};
//# sourceMappingURL=datapoints.js.map